import _classCallCheck from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/createClass";
import { createRenderer } from './renderer-factory.js';
var hasSelf = typeof self !== 'undefined';
export var RoughGeneratorBase =
/*#__PURE__*/
function () {
  function RoughGeneratorBase(config, surface) {
    _classCallCheck(this, RoughGeneratorBase);

    this.defaultOptions = {
      maxRandomnessOffset: 2,
      roughness: 1,
      bowing: 1,
      stroke: '#000',
      strokeWidth: 1,
      curveTightness: 0,
      curveStepCount: 9,
      fillStyle: 'hachure',
      fillWeight: -1,
      hachureAngle: -41,
      hachureGap: -1
    };
    this.config = config || {};
    this.surface = surface;
    this.renderer = createRenderer(this.config);

    if (this.config.options) {
      this.defaultOptions = this._options(this.config.options);
    }
  }

  _createClass(RoughGeneratorBase, [{
    key: "_options",
    value: function _options(options) {
      return options ? Object.assign({}, this.defaultOptions, options) : this.defaultOptions;
    }
  }, {
    key: "_drawable",
    value: function _drawable(shape, sets, options) {
      return {
        shape: shape,
        sets: sets || [],
        options: options || this.defaultOptions
      };
    }
  }, {
    key: "getCanvasSize",
    value: function getCanvasSize() {
      var val = function val(w) {
        if (w && typeof w === 'object') {
          if (w.baseVal && w.baseVal.value) {
            return w.baseVal.value;
          }
        }

        return w || 100;
      };

      if (this.surface) {
        return [val(this.surface.width), val(this.surface.height)];
      }

      return [100, 100];
    }
  }, {
    key: "computePolygonSize",
    value: function computePolygonSize(points) {
      if (points.length) {
        var left = points[0][0];
        var right = points[0][0];
        var top = points[0][1];
        var bottom = points[0][1];

        for (var i = 1; i < points.length; i++) {
          left = Math.min(left, points[i][0]);
          right = Math.max(right, points[i][0]);
          top = Math.min(top, points[i][1]);
          bottom = Math.max(bottom, points[i][1]);
        }

        return [right - left, bottom - top];
      }

      return [0, 0];
    }
  }, {
    key: "polygonPath",
    value: function polygonPath(points) {
      var d = '';

      if (points.length) {
        d = "M".concat(points[0][0], ",").concat(points[0][1]);

        for (var i = 1; i < points.length; i++) {
          d = "".concat(d, " L").concat(points[i][0], ",").concat(points[i][1]);
        }
      }

      return d;
    }
  }, {
    key: "computePathSize",
    value: function computePathSize(d) {
      var size = [0, 0];

      if (hasSelf && self.document) {
        try {
          var ns = 'http://www.w3.org/2000/svg';
          var svg = self.document.createElementNS(ns, 'svg');
          svg.setAttribute('width', '0');
          svg.setAttribute('height', '0');
          var pathNode = self.document.createElementNS(ns, 'path');
          pathNode.setAttribute('d', d);
          svg.appendChild(pathNode);
          self.document.body.appendChild(svg);
          var bb = pathNode.getBBox();

          if (bb) {
            size[0] = bb.width || 0;
            size[1] = bb.height || 0;
          }

          self.document.body.removeChild(svg);
        } catch (err) {}
      }

      var canvasSize = this.getCanvasSize();

      if (!(size[0] * size[1])) {
        size = canvasSize;
      }

      return size;
    }
  }, {
    key: "toPaths",
    value: function toPaths(drawable) {
      var sets = drawable.sets || [];
      var o = drawable.options || this.defaultOptions;
      var paths = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = sets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var drawing = _step.value;
          var path = null;

          switch (drawing.type) {
            case 'path':
              path = {
                d: this.opsToPath(drawing),
                stroke: o.stroke,
                strokeWidth: o.strokeWidth,
                fill: 'none'
              };
              break;

            case 'fillPath':
              path = {
                d: this.opsToPath(drawing),
                stroke: 'none',
                strokeWidth: 0,
                fill: o.fill || 'none'
              };
              break;

            case 'fillSketch':
              path = this.fillSketch(drawing, o);
              break;

            case 'path2Dfill':
              path = {
                d: drawing.path || '',
                stroke: 'none',
                strokeWidth: 0,
                fill: o.fill || 'none'
              };
              break;

            case 'path2Dpattern':
              {
                var size = drawing.size;
                var pattern = {
                  x: 0,
                  y: 0,
                  width: 1,
                  height: 1,
                  viewBox: "0 0 ".concat(Math.round(size[0]), " ").concat(Math.round(size[1])),
                  patternUnits: 'objectBoundingBox',
                  path: this.fillSketch(drawing, o)
                };
                path = {
                  d: drawing.path,
                  stroke: 'none',
                  strokeWidth: 0,
                  pattern: pattern
                };
                break;
              }
          }

          if (path) {
            paths.push(path);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return paths;
    }
  }, {
    key: "fillSketch",
    value: function fillSketch(drawing, o) {
      var fweight = o.fillWeight;

      if (fweight < 0) {
        fweight = o.strokeWidth / 2;
      }

      return {
        d: this.opsToPath(drawing),
        stroke: o.fill || 'none',
        strokeWidth: fweight,
        fill: 'none'
      };
    }
  }, {
    key: "opsToPath",
    value: function opsToPath(drawing) {
      var path = '';
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = drawing.ops[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;
          var data = item.data;

          switch (item.op) {
            case 'move':
              path += "M".concat(data[0], " ").concat(data[1], " ");
              break;

            case 'bcurveTo':
              path += "C".concat(data[0], " ").concat(data[1], ", ").concat(data[2], " ").concat(data[3], ", ").concat(data[4], " ").concat(data[5], " ");
              break;

            case 'qcurveTo':
              path += "Q".concat(data[0], " ").concat(data[1], ", ").concat(data[2], " ").concat(data[3], " ");
              break;

            case 'lineTo':
              path += "L".concat(data[0], " ").concat(data[1], " ");
              break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return path.trim();
    }
  }, {
    key: "lib",
    get: function get() {
      return this.renderer;
    }
  }]);

  return RoughGeneratorBase;
}();